import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/LG350W.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="LG 350W" src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Modules/LG350W.js